import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from '../../../sharpr/api/ApiResourcify.js';
import _ from 'lodash';

export function IntegrationEmbedRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.IntegrationEmbed', {
		url: '/admin/integrations/dashboard-embed',
		controllerAs: 'vm',
		controller: IntegrationEmbedCtrl,
		templateUrl: '/ng/hub/Integration/Embed/IntegrationEmbedCtrl.html?' + window.BUILD,
		permission: ['manage_embed'],
		resolve: {
			style: () => AssetManager.css('/ng/hub/Integration/Embed/IntegrationEmbedCtrl.css'),
			$title: () => 'Embed Codes',
			embeds: ApiResourcify.endpoint('/dashboard_embeds?include_inactive=1'),
		},
	});
}

export class IntegrationEmbedCtrl {
	constructor($state, Api, modal, embeds, notifications) {
		'ngInject';
		this.$state = $state;
		this.Api = Api;
		this.modal = modal;
		this.embeds = embeds;
		this.notifications = notifications;
		this.currentEmbed = {};
		this.serviceOptions = [
			{ id: null, name: 'Choose service...' },
			{ id: 'marketsight', name: 'MarketSight' },
			{ id: 'tableau', name: 'Tableau' },
			{ id: 'power_bi', name: 'Power BI' },
			{ id: 'iframe', name: 'iframe' },
		];
	}

	// Adding a new embed
	addNew() {
		this.isAdding = true;
		this.isAddingOrEditing = true;
	}

	// Remove a particular embed code
	deleteEmbed(embed) {
		const checkMessage = `
		Are you sure you want to delete the <b>${_.escape(embed.title)}</b> embed?
		<br><br>This cannot be undone.`;
		this.modal.confirm({ escapedHtml: checkMessage }).then(() => {
			this.embeds.splice(this.embeds.indexOf(embed), 1);
			this.Api.delete(`/v2/dashboard_embeds/${embed.id}`);
		});
	}

	// Enable or disable an existing embed
	enableOrDisableEmbed(embed) {
		const title = _.escape(embed.title);
		const enableMessage = `Are you sure you want to enable the <b>${title}</b> embed code?<br>This can be disabled again at any time.`;
		const disableMessage = `Are you sure you want to disable the <b>${title}</b> embed code?<br>This can be enabled again at any time.`;
		// show message depending on if it is active or not
		const message = embed.is_active ? disableMessage : enableMessage;
		this.modal.confirm({ escapedHtml: message }).then(() => {
			embed.is_active = !embed.is_active;
			const data = { is_active: embed.is_active };
			this.Api.patch(`/v2/dashboard_embeds/${embed.id}`, data);
		});
	}

	// Edit an existing embed
	edit(embed) {
		// clone the current embed obj
		this.currentEmbed = _.clone(embed);
		this.isAdding = false;
		this.isAddingOrEditing = true;
	}

	isFilledOut() {
		// Check to see if all fields are filled out. Since all are required to save a new embed.
		return this.currentEmbed.title && this.currentEmbed.service && (this.currentEmbed.url || this.currentEmbed.html);
	}

	// Save a new embed
	saveEmbed() {
		if (
			(this.currentEmbed.width && isNaN(Number(this.currentEmbed.width))) ||
			(this.currentEmbed.height && isNaN(Number(this.currentEmbed.height)))
		) {
			this.modal.alert({ text: 'Height and Width must be numbers' });
			return;
		}
		if (this.currentEmbed.advanced) {
			try {
				JSON.parse(this.currentEmbed.advanced);
			} catch (e) {
				this.modal.alert({ text: 'Advanced Config must be valid JSON.' });
				return;
			}
		}

		this.isSaving = true;
		if (this.isAdding) {
			if (this.currentEmbed.service === 'marketsight') {
				this.currentEmbed.html = this.convertMarketSightToIframe(
					this.currentEmbed.url,
					this.currentEmbed.height,
					this.currentEmbed.width
				);
			}
			this.Api.create('/v2/dashboard_embeds', this.currentEmbed).then(
				newId => {
					if (newId > 0) {
						this.savedOk = true;
						this.reload();
					} else {
						this.saveError = 'Unknown error. Please try again.';
						this.isSaving = false;
					}
				},
				() => {
					this.saveError = 'Server error. Please try again.';
					this.isSaving = false;
				}
			);
		} else {
			// editing an embed
			const embed = _.find(this.embeds, { id: this.currentEmbed.id });
			_.extend(embed, this.currentEmbed);
			const data = {
				title: embed.title,
				service: embed.service,
				url: embed.url || '',
				auth_type: embed.auth_type || undefined,
				auth_value: embed.auth_value || undefined,
				advanced: embed.advanced || '',
				html:
					embed.service === 'marketsight'
						? this.convertMarketSightToIframe(embed.url, embed.height, embed.width)
						: embed.html,
				width: Number(embed.width),
				height: Number(embed.height),
			};
			this.Api.patch(`/v2/dashboard_embeds/${embed.id}`, data).then(
				() => {
					this.reload();
				},
				() => {
					this.saveError = 'Server error. Please try again.';
					this.isSaving = false;
				}
			);
		}
	}

	convertMarketSightToIframe(url, height, width) {
		const heightIframe = height ? `height="${height}"` : '';
		const widthIframe = width ? `width="${width}"` : '';
		const heightAndWidthAttributes = `${heightIframe} ${widthIframe}`;
		return `<iframe referrerpolicy="no-referrer" sandbox="allow-same-origin allow-forms allow-modals allow-presentation allow-scripts allow-popups" src="${url}" ${heightAndWidthAttributes}></iframe>`;
	}

	// Update the order in which embeds show on the listing page
	updateOrder() {
		this.embeds.forEach((embed, i) => {
			if (embed.sort === i + 1) {
				return;
			}
			embed.sort = i + 1;
			this.Api.patch(`/v2/dashboard_embeds/${embed.id}`, {
				sort: i + 1,
			});
		});
	}

	// Ran after add/edit of any row
	reload() {
		this.$state.reload();
	}
}
